export default __webpack_public_path__ + "static/media/forceHeavyDuty.1cad43d8.jpg";